
























import {Defecto,GuardarDefecto,EditarDefecto} from '@/entidades/Maestro/Ktb/Defecto';
import ResponseGenerico from '@/entidades/ResponseGenerico';
import Alerta from '@/entidades/Sistema/Alerta';
import Loading from '@/entidades/Sistema/Loading';
import {Vue,Component,Prop} from 'vue-property-decorator'
import {Validations} from 'vuelidate-property-decorators';
import {required} from 'vuelidate/lib/validators'
import { Action } from 'vuex-class';
@Component
export default class FormularioAddTarifa extends Vue
{

  @Action('changeLoading',{namespace:'sistemaModule'}) changeLoading!:Function;
  @Action('changeAlerta',{namespace:'sistemaModule'}) changeAlerta!:Function;
  @Prop({required:true,type:Number})
  action!:number;
  @Prop({required:false})
  modelo!:Defecto;

  descripcion?:string="";
  defectoId?:number =0;

  //Configuracion de validacion
  @Validations()
     validations = {
         descripcion : {required},
     }
 async guardar()
 {
     try
     {
         this.changeLoading(new Loading(true,"Registrando informacion"));
         let response = new ResponseGenerico(false,"");
         let tarifa:Defecto = new Defecto(this.defectoId,this.descripcion,true);
         console.log(tarifa);
         response = this.action == 1 ?  await GuardarDefecto(tarifa) : await EditarDefecto(tarifa);
         if(response.isSuccess == true)
         {
            this.$emit('limpiar');
         }
         else
         {
            this.changeAlerta(new Alerta(response.isMessage,true,"danger",3000));
         }
     }
     catch(error)
     {
         console.log(error);
     }
     finally
     {
         this.changeLoading(new Loading(false,""));
     }
    
 }


 get mensaje()
 {
     if(this.action == 1)
        return {'titulo' : "REGISTRO DE DEFECTO" , 'boton' : "GUARDAR"};
    else
        return {'titulo' : "EDICION DE DEFECTo" , 'boton' : "EDITAR"};
 }

 mounted() {
    if(this.modelo!=undefined)
    {
        this.descripcion = this.modelo.descripcion;
        this.defectoId = this.modelo.defectoId;
    }   
 }

}
